module.exports = __webpack_public_path__ + "34a8e8f9b5078173a79e5ab51b105fda.png";